module.exports = __webpack_public_path__ + "static/media/icon-tattoo.2a4afad0.svg";